import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { RideIconButton, RideGlDown } from '@rimac-seguros/ride-system-components';

import { getTagActionName } from '../../../utils/analytics';
import { removeAccents } from '../../../utils/helpers';

import './styles.scss';

export const AccordionPayment = ({ title, children, className = '' }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    const currentOpen = !open;
    if (currentOpen) {
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Resumen y pago', removeAccents(title), 'trackAction');
    }
    setOpen(currentOpen);
  };

  return (
    <section className={`accordion-payment ${open ? 'active' : ''}`}>
      <div className="accordion-payment_head" onClick={handleOpen}>
        <span>{title}</span>
        <RideIconButton
          glyph={<RideGlDown />}
          size="small"
          variant={open ? 'fill' : 'outline'}
        />
      </div>
      {open && <div className={`accordion-payment_content ${className}`}>{children}</div>}
    </section>
  );
};

AccordionPayment.defaultProps = {
  className: '',
};

AccordionPayment.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
